import React,{useState,useEffect} from 'react'
import { Link  } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import DatePicker from "react-datepicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import axios from "axios";
import config from "../config";
import Pagination  from "../common/Pagination";

function WithDrawlReports() { 
   const [itemsPerPage, setItemsPerPage] = useState(10); 
    const [searchTerm, setSearchTerm] = useState(''); 
    const [reports, setReportsData] = useState([]);
    
  
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [formData, setFormData] = useState({
      startDate: null,
      endDate: null,
      search: '',
      status: ''
    });
    
    const limit = 10; // Number of items per page
    useEffect(() => {
      // Fetch data from the API
    
      getWithDrawlReports();
      
    
    
    }, [currentPage, limit]); // Empty dependency array means this effect runs only once on component mount

    const getWithDrawlReports=()=>{
      const payload = {
        page: currentPage,
        limit: limit,
        search: formData.search,
        startDate: formData.startDate,
        endDate: formData.endDate,
        status: formData.status
      };

      axios.post(`${config.backendUrl}/admin/withdrawals`, payload, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
        })
      .then(response => {
        setReportsData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  
  
   


 
  
   
   
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    };
    const handleSearchChange = (event) => {
      setFormData({
        ...formData,
        search: event.target.value
      });
      setCurrentPage(1); // Reset to first page on search
    };
    const handleStatusChange = (event) => {
      setFormData({
        ...formData,
        status: event.target.value
      });
      setCurrentPage(1);
    };
   
function handleChange(date, fieldName) {
        setFormData(prevState => ({
          ...prevState,
          [fieldName]: date
        }));
      }
//   const sortItems = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };
 

    // const filteredItems = searchTerm ? qrList.filter(item =>
    //   item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||      
    //   item.dateCreated.includes(searchTerm) || 
    //   (item.isRedeemed ? 'Yes' : 'No').toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   (item.redeemedBy && item.redeemedBy.toLowerCase().includes(searchTerm.toLowerCase()))||
    //   item.rewardPoints.toString().includes(searchTerm)

    // ) : qrList;

    // const sortedFilteredItems = filteredItems.sort((a, b) => {
    //   if (a[sortConfig.key] < b[sortConfig.key]) {
    //     return sortConfig.direction === 'ascending' ? -1 : 1;
    //   }
    //   if (a[sortConfig.key] > b[sortConfig.key]) {
    //     return sortConfig.direction === 'ascending' ? 1 : -1;
    //   }
    //   return 0;
    // });
      const handleReset = () => {
        const clearedFilters = {
        startDate: null,
        endDate: null,
        status: "",
        search: ""
      };

      setFormData(clearedFilters);
  // Call API only if already cleared
    if (
      !formData.startDate &&
      !formData.endDate &&
      !formData.status &&
      !formData.search
    ) {
      getWithDrawlReports();
    }
    };

 const handleApplyFilters = () => {
  // Call your API / filter logic
  console.log("Applying filters with data:", formData);
  getWithDrawlReports();
  // Example: fetchData(formData)
};



    
  return (
    <> 
  
 
    <div className='flex justify-between items-center pt-[70px]'> 
      <div> 
        <h2> Withdrawal Report</h2>
        <div className='breadcrumbs'> <Link to="/admin/dashboard">Home</Link>{">"} Withdrawal Report </div>
      </div>
        <div className='flex gap-2 items-center'> 
        <div>
        {/* <button className='genreport-btn'>Generate Report</button> */}
      </div> 
      <div className='flex gap-2 mob-wrap mob-alignfilters'> 
          {/* <div className='flex table-search bg-white'>
          <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <IoIosSearch />
          </div> */}
       
        </div>
    <div>
        
      </div> 
    
    </div>
</div>
    
    
    <div  className='whitebox'>
        
      {/* <form>
  <div className="flex justify-between mb-4"> 
    <h4 className="font-semibold">Statistics</h4>

    <div className="flex gap-4">  

     
      <div className="date-filters flex gap-2">
        <div className="flex items-center border rounded px-2 py-1">
          <DatePicker 
            selected={formData.startDate} 
            onChange={(date) => handleChange(date, 'startDate')}
            name="startDate" 
            placeholderText="From date"
            className="outline-none"
          /> 
          <FaRegCalendarAlt className="ml-2 text-gray-500" />
        </div>

        <div className="flex items-center border rounded px-2 py-1">
          <DatePicker 
            selected={formData.endDate} 
            onChange={(date) => handleChange(date, 'endDate')}
            name="endDate" 
            placeholderText="To date"
            className="outline-none"
          />
          <FaRegCalendarAlt className="ml-2 text-gray-500" />
        </div>
      </div>

      
      <select 
        value={formData.status} 
        onChange={handleStatusChange}
        className="sort-dropdown w-40 border rounded px-2 py-1"
      >
        <option value="">All Status</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="failed">Failed</option>
        <option value="processing">Processing</option>
      </select>
     
     
      <div className="flex items-center  rounded px-2 py-1">
        <input
          type="text"
          placeholder="Search"
          value={formData.search}
          name="search"
          onChange={handleSearchChange}
          className="outline-none"
        />
       
      </div>

    </div>
  </div>
      </form> */}
<form>
  <div className="flex justify-between mb-4"> 
    <h4 className="font-semibold">Statistics</h4>

    <div className="flex gap-4">  

      {/* Date Filters */}
      <div className="date-filters flex gap-2">
        <div className="flex items-center border rounded px-2 py-1">
          <DatePicker 
            selected={formData.startDate} 
            onChange={(date) => handleChange(date, 'startDate')}
            name="startDate" 
            placeholderText="From date"
            className="outline-none"
          /> 
          <FaRegCalendarAlt className="ml-2 text-gray-500" />
        </div>

        <div className="flex items-center border rounded px-2 py-1">
          <DatePicker 
            selected={formData.endDate} 
            onChange={(date) => handleChange(date, 'endDate')}
            name="endDate" 
            placeholderText="To date"
            className="outline-none"
          />
          <FaRegCalendarAlt className="ml-2 text-gray-500" />
        </div>
      </div>

      {/* Status Dropdown */}
      <select 
        value={formData.status} 
        onChange={handleStatusChange}
        className="sort-dropdown w-40 border rounded px-2 py-1"
      >
        <option value="">All Status</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="failed">Failed</option>
        <option value="processing">Processing</option>
      </select>
     
      {/* Search Input */}
      <div className="flex items-center  rounded px-2 py-1">
        <input
          type="text"
          placeholder="Search"
          value={formData.search}
          name="search"
          onChange={handleSearchChange}
          className="outline-none"
        />
        {/* <IoIosSearch className="ml-2 text-gray-500" /> */}
      </div>

      {/* Buttons */}
      <div className="flex items-center gap-2">
        <button 
          type="button"
          onClick={handleApplyFilters}
          className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-500 transition"
        >
          Filter
        </button>

        <button 
          type="button"
          onClick={handleReset}
          className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-700 transition"
        >
          Reset
        </button>
      </div>

    </div>
  </div>
</form>


    <div>
      <table className='tablegrid table-auto w-full border-collapse border' width={"100%"}>
        <thead>
          <tr className='bg-gray-100 text-left'>
            <th style={{width: "60px"}}>S.No</th>
            <th style={{width: "150px"}}>Name</th>
            <th style={{width: "120px"}}>Phone Number</th>
            <th style={{width: "100px"}}>PaymentMode</th>
            <th style={{width: "120px"}}>Redeemed Points</th>
            <th style={{width: "130px"}}>Withdrawl Amount</th>
            <th style={{width: "100px"}}>Date</th>
            <th style={{width: "120px"}}>Payment Status</th>
            <th style={{width: "150px"}}>Transaction ID</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 ? (
            <tr>
              <td colSpan="9" align="center">No records available</td>
            </tr>
          ) : (
            reports.map((item, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * limit}</td>
                <td className="redfont">{item.name || '-'}</td>
                <td>{item.phone_number || '-'}</td>
                <td>{item.payment_mode || '-'}</td>
                <td>{item.redeemed_points || 0}</td>
                <td>{item.withdrawal_amount || 0}</td>
                <td>{item.date || '-'}</td>
                <td>{item.payment_status || 'Pending'}</td>
                <td>{item.transaction_id || '-'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="flex justify-between">
          <div> </div>
          <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
             />

        </div>
      </div>

    </div>

    {/* {PopoverprevId && (
          <Popover onClose={handleCloseprevPopover} isVisible={setPopoverprevId !== null}>
            <Preview></Preview>
          </Popover>
        )}
  */}
    
    </>
  )
}

export default WithDrawlReports
